import * as React from "react";

/**
 * Splits text by case-insensitive occurrences of `term` and wraps matches in <strong>.
 * Returns a React fragment; use for highlighting search matches in option labels.
 */
export function highlightSearchTerm(text: string, term: string): React.ReactNode {
  if (!text) return text;
  if (!term || !term.trim()) return text;

  const normalizedText = text;
  const normalizedTerm = term.trim();
  const lowerText = normalizedText.toLowerCase();
  const lowerTerm = normalizedTerm.toLowerCase();

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let index = lowerText.indexOf(lowerTerm);
  let keyIndex = 0;

  while (index !== -1) {
    if (index > lastIndex) {
      parts.push(<React.Fragment key={`t-${keyIndex++}`}>{normalizedText.slice(lastIndex, index)}</React.Fragment>);
    }
    parts.push(
      <strong key={`s-${keyIndex++}`} className="font-semibold">
        {normalizedText.slice(index, index + normalizedTerm.length)}
      </strong>,
    );
    lastIndex = index + normalizedTerm.length;
    index = lowerText.indexOf(lowerTerm, lastIndex);
  }

  if (lastIndex < normalizedText.length) {
    parts.push(<React.Fragment key={`t-${keyIndex}`}>{normalizedText.slice(lastIndex)}</React.Fragment>);
  }

  if (parts.length === 0) return text;
  return <>{parts}</>;
}
